<!-- ChartIcon.vue -->
<template>
  <svg :class="iconClass" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <!-- Chart bars -->
    <rect 
      x="4" 
      y="14" 
      width="3" 
      height="8" 
      stroke="#333333" 
      stroke-width="1.5" 
      stroke-miterlimit="10" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    
    <rect 
      x="10.5" 
      y="8" 
      width="3" 
      height="14" 
      stroke="#333333" 
      stroke-width="1.5" 
      stroke-miterlimit="10" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    
    <rect 
      x="17" 
      y="2" 
      width="3" 
      height="20" 
      stroke="#333333" 
      stroke-width="1.5" 
      stroke-miterlimit="10" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    
    <!-- Base line (x-axis) -->
    <path 
      d="M2 22H22" 
      stroke="#333333" 
      stroke-width="1.5" 
      stroke-miterlimit="10" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
defineProps({
  iconClass: {
    type: String,
    default: '',
  }
});
</script>